import { usePepwiseAuthController } from 'Context/contexts/AuthContext';

export interface SectorFilterResult {
	shouldFilter: boolean;
	sectorNames: string[];
}

const useFinOpsSectorFilter = (): SectorFilterResult => {
	const [{ role, privilege, sector, sectorViewer }] = usePepwiseAuthController();

	const isFinOpsUser = Array.isArray(role) && role.some((r) => r.toLowerCase() === 'finops user');
	const isViewer = privilege === 'Viewer';
	const hasSectors =
		(sector?.name && sector.name !== 'ALL') ||
		(Array.isArray(sectorViewer) && sectorViewer.length > 0);

	if (!isFinOpsUser || !isViewer || !hasSectors) {
		return { shouldFilter: false, sectorNames: [] };
	}

	const names: string[] = [];

	if (sector?.name && sector.name !== 'ALL') {
		names.push(sector.name);
	}

	if (Array.isArray(sectorViewer)) {
		sectorViewer.forEach((s) => {
			if (s.name && !names.includes(s.name)) {
				names.push(s.name);
			}
		});
	}

	return { shouldFilter: true, sectorNames: names };
};

export default useFinOpsSectorFilter;
